import slideDown from './slide-down';

/**
 * Shows the mobile menu with a slide-down animation.
 *
 * This function adds an active class to the element and triggers a slide-down animation on the menu.
 *
 * @param {HTMLElement} el - The element that triggers the show action.
 * @param {HTMLElement} menu - The menu element to show.
 * @param {Object} params - Configuration parameters.
 * @param {number} params.mobileSpeed - The speed of the slide-down animation.
 * @param {Object} itemParams - Item-specific parameters.
 * @param {Function} itemParams.activeItemClass - A function that returns the active item class.
 * @returns {void}
 */
export default function mobileShow(el, menu, params, itemParams) {
  if (!el || !menu || !params || !itemParams) {
    console.error('Invalid arguments provided to mobileShow');
    return;
  }

  const activeClass = itemParams.activeItemClass();
  if (typeof activeClass !== 'string') {
    console.error('activeItemClass function did not return a string');
    return;
  }

  el.classList.add(activeClass.slice(1));
  slideDown(menu, params.mobileSpeed);
}
